namespace $.$$ {

	$mol_style_define( $shm_projects_tasks, {
		List: {
			flex: { basis: '16rem', grow: 0, shrink: 0 },
		},
	} )

}
